import { useMaterializedProcessesDataTable } from 'generated/resources/datatable.graphql'

import statusFilter from './Status'

export const filters = (source: ReturnType<typeof useMaterializedProcessesDataTable>) => [
  statusFilter(source),
]
